import { render } from "./CustomAutocomplete.vue?vue&type=template&id=670cabc6&scoped=true"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=js"

import "./CustomAutocomplete.vue?vue&type=style&index=0&id=670cabc6&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670cabc6"]])

export default __exports__